import { Component, inject, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { Platform } from 'src/app/shared/enums/generated.enums';
import { SubPageType } from 'src/app/shared/enums/page-type.enum';
import { TenantsService } from 'src/app/shared/services/tenants.service';
import { ContactUsModalComponent } from '../../../shared/components/_modals/contact-us-modal/contact-us-modal.component';
import { ModalService } from '../../../shared/services/modal.service';

@Component({
  selector: 'app-rpa-not-connected',
  templateUrl: './rpa-not-connected.component.html',
  styleUrls: ['./rpa-not-connected.component.scss'],
  standalone: false,
})
export class RpaNotConnectedComponent implements OnInit {
  private readonly modalService = inject(ModalService);
  private readonly navigationService = inject(NavigationService);
  private readonly tenantService = inject(TenantsService);

  displayNavToSettings: boolean;

  get platformName(): Platform | null {
    return this.tenantService.selectedTenantPlatform;
  }

  ngOnInit(): void {
    this.displayNavToSettings = this.navigationService.getOrganizationSettingsRoute(SubPageType.TenantsSettings) != null;
  }

  async navToSettings(): Promise<void> {
    await this.navigationService.navigateToOrganizationSettings(SubPageType.TenantsSettings);
  }

  openContactSupportModal(): void {
    this.modalService.open(ContactUsModalComponent);
  }
}
